export default __webpack_public_path__ + "static/media/Slider_4500_Web.d73037bc.png";